import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { CardBody, Container, ModalBody, Modal } from 'reactstrap';
import { Card } from 'reactstrap';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation } from 'react-router-dom';
import { requisition_create } from '../../api/requisition';
import { useNavigate } from 'react-router-dom';
import SweetAlert from "react-bootstrap-sweetalert";
import LinearProgress from '@mui/material/LinearProgress';
import { toast } from 'react-toastify';
import {formatValueWithCommas} from '../helper'
import { useDispatch, useSelector} from 'react-redux';
import { approveRequisitionItem, createProcurementRelation} from "../../api/approval";
import { StorePageHeaderName } from '../../store/pageHeader/action';

const SubmissionRequisition = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Requisition Submission'));

    const location = useLocation();
    const  rows  = location.state.checkedRows;

    const [isLoading, setIsLoading] = useState(false); // New state variable for loading indicator
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const navigate = useNavigate();
    const loggedInUser = useSelector((state) => state.Profile.user);

    
    
   // Group the array based on the Item_no attribute and sum Total_Qty and Value
const groupedData = rows.reduce((acc, obj) => {
    const { Item_no, Total_Qty, Value, category, dp, id, itemseg, mop, p_type, remaining, vertical, approved,Product_Name, vcode,vname,vtype } = obj;
    
    if (!acc[Item_no]) {
        acc[Item_no] = {
            Total_Qty: 0,
            Value: 0,
            category: '',
            dp: 0,
            id: null,
            itemseg: '',
            mop: 0,
            p_type: '',
            remaining: 0,
            vertical: '',
            items: [],
            Item_no,
            Product_Name,
            vcode,
            vname,
            vtype
        };
    }
    
    acc[Item_no].Total_Qty += approved;
    acc[Item_no].Value += Value;
    acc[Item_no].category = category;
    acc[Item_no].dp = dp;
    acc[Item_no].id = id;
    acc[Item_no].itemseg = itemseg;
    acc[Item_no].mop = mop;
    acc[Item_no].p_type = p_type;
    acc[Item_no].remaining = remaining;
    acc[Item_no].vertical = vertical;
    acc[Item_no].Item_no = Item_no;
    acc[Item_no].Product_Name = Product_Name;
    acc[Item_no].vcode = vcode;
    acc[Item_no].vname = vname;
    acc[Item_no].vtype = vtype;



    acc[Item_no].items.push(obj);
    
    return acc;
}, {});

// Convert the grouped data object into an array of objects
const groupedArray = Object.values(groupedData);
const totalQtySum = groupedArray.reduce((acc, row) => acc + row.Total_Qty, 0);
const valueSum = groupedArray.reduce((acc, row) => acc + row.Value, 0);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const openModal = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };


   
    const submitRequisition = async () => {
        try {
            closeModal(); // Closing the modal when 'No' button is clicked
            setIsLoading(true)

            const stateHeadReq = groupedArray.map(item =>({
                total_qty: item.Total_Qty,
                value: item.Value,
                item_name: item.Product_Name,
                item_no: item.Item_no,
                p_type: item.p_type,
                vertical: item.vertical,
                itemseg: item.itemseg,
                category: item.category,
                dp: item.dp,
                mop:item.mop,
                vcode: item.vcode,
                vname: item.vname,
                vtype: item.vtype
            }))
              
            const createReq = await requisition_create({requisition_data:[ {req_total:valueSum,req_item_count: totalQtySum, user_id:loggedInUser.userDetails.id,  items:stateHeadReq}]} )
            if(createReq.statusCode === 201 && createReq.data.requisitionItemDetails.length > 0){
                const res = createReq.data
                const structuredRows = rows.map(row => ({
                    requisition_item_id: row.Requisition_item_id,
                    approved_qty: row.approved,
                    status: row.approved < row.Total_Qty ? 'PARTIALLY_APPROVED': row.approved === row.Total_Qty? 'COMPLETE_APPROVED':'EXCESS_APPROVED'
                  }));
                
                const approve = await approveRequisitionItem(structuredRows)
                if(approve.statusCode === 200) {
                    
                    const relation = rows.map(row => {
                        const matchedItem = res.requisitionItemDetails.find(item => item.item_no === row.Item_no);
                      
                        return {
                          child_req_item_id: row.Requisition_item_id,
                          child_req_id: row.Requisition_id,
                          parent_req_id: matchedItem.requisition_id,
                          parent_req_item_id: matchedItem.id
                        };
                      });
                      const back_track = await createProcurementRelation(relation)
                      if(back_track.statusCode === 200){
                        setIsOpenSweetAlert(true);
                      }
                }

            }

        }
        catch (e){
            console.log(e)
            toast.error('Error in creating sales head requisition')
        }
        finally {
            setIsLoading(false); // Reset loading state after operation completes
        }
    };

    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);

        navigate("/sales-head/approval-requisition");

    };
    const handleNavigate = () => {
        navigate('/sales-head/create-requisition', { state: { prevRoute: '/sales-head/add-requisition' }});
    };
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                {isLoading && ( // Conditional rendering of loader
                <div className="loader-container">
                    <LinearProgress />
                </div>
                )}
                    <div className='mb-3' style={{ fontSize: '20px', fontWeight: '500' }}>
                        <span className='me-2' onClick={handleNavigate}><ArrowBackIcon /></span>
                        <span>Requisition</span>
                    </div>
                    <Card>
                        <CardBody>
                            <div>
                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Product Name</th>
                                            <th>Quantity</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                    {groupedArray.map((row, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{row.Product_Name}</td>
                                            <td>{row.Total_Qty}</td>
                                            <td>{formatValueWithCommas(row.Value)}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                    <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="2">Total :</th>
                                            <td>{totalQtySum}</td>
                                            <td>{formatValueWithCommas(valueSum)}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                    <div className='mb-2' style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px', marginRight: '8px', marginBottom: '3px', borderTop: '1px solid #ccc', paddingTop: '8px' }}>
                        <button className="save_button" variant="contained" onClick={openModal}>Submit</button>
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do You Want To Submit This Requisition</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i className="ri-close-line" onClick={closeModal}></i>
                    </div>
                </div>
                <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                <ModalBody className='pt-2'>
                    <div>
                        <div>
                            <p className='mb-0'>If 'Yes', then you won't be able to modify or edit your request. If 'No', then you can continue your modification.</p>
                        </div>
                    </div>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" onClick={() => {
                    submitRequisition();
                }}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={closeModal}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <SweetAlert
                show={isOpenSweetAlert}
                title='Requisition created successfully'
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />
        </React.Fragment>
    );
}

export default SubmissionRequisition;
